// <auto-generated />
// This file was generated by Medfar's Pdf Mapping Inkscape extension.
// Don't change it directly as your change would get overwritten.
// For more info take a look at the extension README (Myle.PdfFormGenerator/InkscapeExtension/readme.md)
// and the pdf generator README(Myle.PdfFormGenerator/readme.md)

class BritishColumbiaObstetricalFileFieldLimits {
    public static Page1 = {
        AgeAtEstimatedDateOfDelivery: { MaxChars: 16, MaxRows: 1 },
        Allergies: { MaxChars: 32, MaxRows: 1 },
        BeliefsPractice: { MaxChars: 26, MaxRows: 1 },
        BiologicalFatherAge: { MaxChars: 4, MaxRows: 1 },
        BiologicalFatherEthnicity: { MaxChars: 9, MaxRows: 1 },
        BiologicalFatherName: { MaxChars: 22, MaxRows: 1 },
        ContraceptivesType: { MaxChars: 16, MaxRows: 1 },
        Ethnicity: { MaxChars: 16, MaxRows: 1 },
        FamilyHistory_AnestheticComplicationsDescription: { MaxChars: 17, MaxRows: 1 },
        FamilyHistory_DiabetesDescription: { MaxChars: 27, MaxRows: 1 },
        FamilyHistory_HypertensionDescription: { MaxChars: 24, MaxRows: 1 },
        FamilyHistory_InheritedConditionsOrDefects_BiologicalFatherDescription: { MaxChars: 22, MaxRows: 1 },
        FamilyHistory_InheritedConditionsOrDefects_MotherDescription: { MaxChars: 28, MaxRows: 1 },
        FamilyHistory_MentalHealthDescription: { MaxChars: 24, MaxRows: 1 },
        FamilyHistory_OtherDescription: { MaxChars: 28, MaxRows: 1 },
        FamilyHistory_SubstanceUseDisorderDescription: { MaxChars: 18, MaxRows: 1 },
        FamilyHistory_ThromboembolicDescription: { MaxChars: 22, MaxRows: 1 },
        FamilyPhysicianOrNursePractitionerName: { MaxChars: 32, MaxRows: 1 },
        GestationalAgeByUltrasound: { MaxChars: 12, MaxRows: 1 },
        GravidaCounter: { MaxChars: 4, MaxRows: 1 },
        HighestLevelOfEducationCompleted: { MaxChars: 32, MaxRows: 1 },
        InducedAbortionCounter: { MaxChars: 4, MaxRows: 1 },
        InitialPhysicalExamination_AbdomenDescription: { MaxChars: 27, MaxRows: 1 },
        InitialPhysicalExamination_BloodPressure: { MaxChars: 13, MaxRows: 1 },
        InitialPhysicalExamination_BreastsAndNipplesDescription: { MaxChars: 22, MaxRows: 1 },
        InitialPhysicalExamination_CompletedBy: { MaxChars: 18, MaxRows: 1 },
        InitialPhysicalExamination_HeadAndNeckDescription: { MaxChars: 25, MaxRows: 1 },
        InitialPhysicalExamination_HeartAndLungsDescription: { MaxChars: 24, MaxRows: 1 },
        InitialPhysicalExamination_HeartRatePerMinute: { MaxChars: 8, MaxRows: 1 },
        InitialPhysicalExamination_HeightCentimeter: { MaxChars: 11, MaxRows: 1 },
        InitialPhysicalExamination_MusculoskeletalDescription: { MaxChars: 23, MaxRows: 1 },
        InitialPhysicalExamination_OtherDescription: { MaxChars: 28, MaxRows: 1 },
        InitialPhysicalExamination_Pelvic_PapTest_Comments: { MaxChars: 13, MaxRows: 1 },
        InitialPhysicalExamination_Pelvic_SexuallyTransmittedDiseasesTest_Comments: { MaxChars: 13, MaxRows: 1 },
        InitialPhysicalExamination_PelvicDescription: { MaxChars: 28, MaxRows: 1 },
        InitialPhysicalExamination_PrePregnancyBodyMassIndex: { MaxChars: 5, MaxRows: 1 },
        InitialPhysicalExamination_PrePregnancyWeightInKilogram: { MaxChars: 4, MaxRows: 1 },
        InitialPhysicalExamination_Skin_OtherDescription: { MaxChars: 22, MaxRows: 1 },
        LifestyleSocialConcerns_DietNutritionDescription: { MaxChars: 24, MaxRows: 1 },
        LifestyleSocialConcerns_ExerciseDescription: { MaxChars: 27, MaxRows: 1 },
        LifestyleSocialConcerns_FinancialDescription: { MaxChars: 27, MaxRows: 1 },
        LifestyleSocialConcerns_HousingFoodSecurityDescription: { MaxChars: 18, MaxRows: 1 },
        LifestyleSocialConcerns_OtherDescription: { MaxChars: 28, MaxRows: 1 },
        LifestyleSocialConcerns_RelationshipsSupportDescription: { MaxChars: 18, MaxRows: 1 },
        LifestyleSocialConcerns_SafetyDescription: { MaxChars: 28, MaxRows: 1 },
        LifestyleSocialConcerns_TransportationDescription: { MaxChars: 23, MaxRows: 1 },
        LivingCounter: { MaxChars: 4, MaxRows: 1 },
        MedicalHistory_AbdomenGastrointestinalDescription: { MaxChars: 26, MaxRows: 1 },
        MedicalHistory_AnestheticComplicationsDescription: { MaxChars: 16, MaxRows: 1 },
        MedicalHistory_CardioVascular_OtherDescription: { MaxChars: 23, MaxRows: 1 },
        MedicalHistory_Endocrine_OtherDescription: { MaxChars: 16, MaxRows: 1 },
        MedicalHistory_GyneGenitourinaryDescription: { MaxChars: 25, MaxRows: 1 },
        MedicalHistory_HematologyDescription: { MaxChars: 34, MaxRows: 1 },
        MedicalHistory_Immunizations_OtherDescription: { MaxChars: 16, MaxRows: 1 },
        MedicalHistory_InfectiousDiseases_OtherDescription: { MaxChars: 14, MaxRows: 1 },
        MedicalHistory_MentalHealth_OtherDescription: { MaxChars: 16, MaxRows: 1 },
        MedicalHistory_NeuroDescription: { MaxChars: 27, MaxRows: 1 },
        MedicalHistory_OtherDescription: { MaxChars: 28, MaxRows: 1 },
        MedicalHistory_RespDescription: { MaxChars: 28, MaxRows: 1 },
        MedicalHistory_SurgeryDescription: { MaxChars: 26, MaxRows: 1 },
        Medications: { MaxChars: 38, MaxRows: 1 },
        ObstetricalHistory_BreastfedDuration: { MaxChars: 6, MaxRows: 1 },
        ObstetricalHistory_ChildPresentHealth: { MaxChars: 9, MaxRows: 1 },
        ObstetricalHistory_Comments: { MaxChars: 50, MaxRows: 1 },
        ObstetricalHistory_DurationOfLabour: { MaxChars: 8, MaxRows: 1 },
        ObstetricalHistory_GestationalAge: { MaxChars: 8, MaxRows: 1 },
        ObstetricalHistory_ModeOfBirth: { MaxChars: 5, MaxRows: 1 },
        ObstetricalHistory_PlaceOfBirth: { MaxChars: 8, MaxRows: 1 },
        ObstetricalHistory_Sex: { MaxChars: 3, MaxRows: 1 },
        ObstetricalHistory_Weight: { MaxChars: 6, MaxRows: 1 },
        PartnerName: { MaxChars: 32, MaxRows: 1 },
        PartnerOccupation: { MaxChars: 32, MaxRows: 1 },
        PatientAddress: { MaxChars: 192, MaxRows: 4 },
        PatientOccupation: { MaxChars: 32, MaxRows: 1 },
        PatientPersonalHealthNumber: { MaxChars: 48, MaxRows: 1 },
        PatientPhoneNumber: { MaxChars: 48, MaxRows: 1 },
        PreferredLanguage: { MaxChars: 16, MaxRows: 1 },
        PreferredNameOrPronoun: { MaxChars: 16, MaxRows: 1 },
        PresentPregnancy_AntiretroviralTherapy_IntracytoplasmicSpermInjectionNumberOfEmbryos: { MaxChars: 5, MaxRows: 1 },
        PresentPregnancy_AntiretroviralTherapy_InVitroFertilizationNumberOfEmbryos: { MaxChars: 5, MaxRows: 1 },
        PresentPregnancy_AntiretroviralTherapy_OtherDescription: { MaxChars: 26, MaxRows: 1 },
        PresentPregnancy_BleedingDescription: { MaxChars: 27, MaxRows: 1 },
        PresentPregnancy_InfectionRashFeverDescription: { MaxChars: 20, MaxRows: 1 },
        PresentPregnancy_NauseaDescription: { MaxChars: 28, MaxRows: 1 },
        PresentPregnancy_OtherDescription: { MaxChars: 58, MaxRows: 2 },
        PresentPregnancy_TravelDescription: { MaxChars: 20, MaxRows: 1 },
        PretermCounter: { MaxChars: 4, MaxRows: 1 },
        PrimaryMaternityCareProviderName: { MaxChars: 32, MaxRows: 1 },
        RelationshipStatus: { MaxChars: 16, MaxRows: 1 },
        Section11_CareProvider: { MaxChars: 10, MaxRows: 1 },
        Section11_CommentsFollowUp: { MaxChars: 380, MaxRows: 10 },
        SpontaneousAbortionCounter: { MaxChars: 4, MaxRows: 1 },
        SubstanceUse_3MonthsBeforePregnancy_CannabisUsedPer: { MaxChars: 5, MaxRows: 1 },
        SubstanceUse_3MonthsBeforePregnancy_CigarettesPerDay: { MaxChars: 14, MaxRows: 1 },
        SubstanceUse_3MonthsBeforePregnancy_DrinksPerWeek: { MaxChars: 14, MaxRows: 1 },
        SubstanceUse_DuringPregnancy_CannabisUsedPer: { MaxChars: 5, MaxRows: 1 },
        SubstanceUse_DuringPregnancy_CigarettesPerDay: { MaxChars: 14, MaxRows: 1 },
        SubstanceUse_DuringPregnancy_DrinksPerWeek: { MaxChars: 14, MaxRows: 1 },
        SubstanceUse_OthersDuringPregnancy_OthersDescription: { MaxChars: 7, MaxRows: 1 },
        SurnameAtBirth: { MaxChars: 16, MaxRows: 1 },
        TermCounter: { MaxChars: 4, MaxRows: 1 }
    };

    public static Page2 = {
        PatientAddress: { MaxChars: 192, MaxRows: 4 },
        PatientGivenNames: { MaxChars: 16, MaxRows: 1 },
        PatientPersonalHealthNumber: { MaxChars: 48, MaxRows: 1 },
        PatientPhoneNumber: { MaxChars: 48, MaxRows: 1 },
        PatientSurname: { MaxChars: 16, MaxRows: 1 },
        Section12_PlannedPlaceOfBirthAt20Weeks: { MaxChars: 14, MaxRows: 1 },
        Section12_PlannedPlaceOfBirthAt36Weeks: { MaxChars: 14, MaxRows: 1 },
        Section12_ReferralHospital: { MaxChars: 11, MaxRows: 1 },
        Section13_BloodType: { MaxChars: 6, MaxRows: 1 },
        Section13_Chlamydia_TestResults_Comments: { MaxChars: 20, MaxRows: 1 },
        Section13_GlucoseChallengeTest_TestResults_At1HourValue: { MaxChars: 4, MaxRows: 1 },
        Section13_GlucoseToleranceTest_TestResults_ValueAt1Hour: { MaxChars: 4, MaxRows: 1 },
        Section13_GlucoseToleranceTest_TestResults_ValueAt2Hour: { MaxChars: 4, MaxRows: 1 },
        Section13_GlucoseToleranceTest_TestResults_ValueAt3Hour: { MaxChars: 4, MaxRows: 1 },
        Section13_Gonorrhea_TestResults_Comments: { MaxChars: 20, MaxRows: 1 },
        Section13_Hemoglobin_FirstTrimester: { MaxChars: 9, MaxRows: 1 },
        Section13_Hemoglobin_ThirdTrimester: { MaxChars: 9, MaxRows: 1 },
        Section13_HepatitisBSurfaceAntigen_TestResults_DnaValue: { MaxChars: 7, MaxRows: 1 },
        Section13_HumanImmunodeficiencyVirus_TestResultsComments: { MaxChars: 20, MaxRows: 1 },
        Section13_OtherTestResults: { MaxChars: 130, MaxRows: 2 },
        Section13_PrenatalGeneticInvestigations_OtherComments: { MaxChars: 10, MaxRows: 1 },
        Section13_Results: { MaxChars: 51, MaxRows: 3 },
        Section13_RhesusFactor: { MaxChars: 7, MaxRows: 1 },
        Section13_Rubella_TestResults_Value: { MaxChars: 7, MaxRows: 1 },
        Section13_Syphilis_TestResults_Comments: { MaxChars: 40, MaxRows: 1 },
        Section13_UrineCultureAndSensitivity_TestResults_Comments: { MaxChars: 20, MaxRows: 1 },
        Section13_UrineCultureAndSensitivity_TestResults_CultureValue: { MaxChars: 14, MaxRows: 1 },
        Section14_DepressionScale_AnxietySubscore: { MaxChars: 6, MaxRows: 1 },
        Section14_DepressionScale_FollowUp: { MaxChars: 58, MaxRows: 1 },
        Section14_DepressionScale_GestationalAge: { MaxChars: 8, MaxRows: 1 },
        Section14_DepressionScale_SelfHarmSubscore: { MaxChars: 5, MaxRows: 1 },
        Section14_DepressionScale_TotalScore: { MaxChars: 6, MaxRows: 1 },
        Section15_Ultrasounds_Comments: { MaxChars: 34, MaxRows: 1 },
        Section15_Ultrasounds_Date: { MaxChars: 8, MaxRows: 1 },
        Section15_Ultrasounds_GestationalAge: { MaxChars: 6, MaxRows: 1 },
        Section16_PerinatalConsiderations_Breastfeeding: { MaxChars: 40, MaxRows: 1 },
        Section16_PerinatalConsiderations_ContraceptionPlan: { MaxChars: 37, MaxRows: 1 },
        Section16_PerinatalConsiderations_LabourAndBirth: { MaxChars: 39, MaxRows: 1 },
        Section16_PerinatalConsiderations_LifestyleSubstanceUse: { MaxChars: 34, MaxRows: 1 },
        Section16_PerinatalConsiderations_Newborn: { MaxChars: 43, MaxRows: 1 },
        Section16_PerinatalConsiderations_Postpartum: { MaxChars: 41, MaxRows: 1 },
        Section16_PerinatalConsiderations_Pregnancy: { MaxChars: 42, MaxRows: 1 },
        Section17_Visit_BloodPressure: { MaxChars: 10, MaxRows: 2 },
        Section17_Visit_Comments: { MaxChars: 96, MaxRows: 2 },
        Section17_Visit_Date: { MaxChars: 14, MaxRows: 2 },
        Section17_Visit_FetalHeartRate: { MaxChars: 10, MaxRows: 2 },
        Section17_Visit_FetalMovement: { MaxChars: 10, MaxRows: 2 },
        Section17_Visit_Fundus: { MaxChars: 10, MaxRows: 2 },
        Section17_Visit_GestationalAge: { MaxChars: 12, MaxRows: 2 },
        Section17_Visit_Initials: { MaxChars: 10, MaxRows: 2 },
        Section17_Visit_NextVisit: { MaxChars: 10, MaxRows: 2 },
        Section17_Visit_PresentationAndPosition: { MaxChars: 10, MaxRows: 2 },
        Section17_Visit_Urine: { MaxChars: 12, MaxRows: 2 },
        Section17_Visit_Weight: { MaxChars: 10, MaxRows: 2 },
        Section18_Name_1: { MaxChars: 44, MaxRows: 1 },
        Section18_Name_2: { MaxChars: 44, MaxRows: 1 },
        Section18_Name_3: { MaxChars: 44, MaxRows: 1 }
    };

    public static Page3 = {
        Section14_EPDS_InterpretationAndActions_AnxietySubscore: { MaxChars: 8, MaxRows: 2 },
        Section14_EPDS_InterpretationAndActions_SelfHarmSubscore: { MaxChars: 8, MaxRows: 2 },
        Section14_EPDS_InterpretationAndActions_TotalScore: { MaxChars: 16, MaxRows: 2 }
    };

    public static Page4 = {
        PatientAddress: { MaxChars: 192, MaxRows: 4 },
        PatientGivenNames: { MaxChars: 16, MaxRows: 1 },
        PatientPersonalHealthNumber: { MaxChars: 48, MaxRows: 1 },
        PatientPhoneNumber: { MaxChars: 48, MaxRows: 1 },
        PatientSurname: { MaxChars: 16, MaxRows: 1 }
    };
}

export { BritishColumbiaObstetricalFileFieldLimits };
